module.exports = __webpack_public_path__ + "media/LandingPageAssets/BlueFlame-20029d53.png";